import {React, useEffect} from 'react';
import {laSportsImage4} from '../../assets';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as RedPageAfterSVG } from '../../assets/SVG/RedPageAfter.svg';
import { red1, red2, red3, red4 } from '../../assets';

const redImageMap = {
  './images/puzzles/red/red1.png': red1,
  './images/puzzles/red/red2.png': red2,
  './images/puzzles/red/red3.png': red3,
  './images/puzzles/red/red4.png': red4
};
const RedPageAfter = ({ feedback, onNext, isTrue, wrongImage, correctImage }) => {
  const navigate = useNavigate();
    useEffect(() => {
      const homeWiseathlete = document.getElementById('home_wiseathlete');
      const correctBoxRed = document.getElementById('correct-box-red');
      const tryAgainBoxRed = document.getElementById('Try-again-box-red');
      const photoBoxRed = document.getElementById('photo-box-red');
      const tryAgainBoxRedtext = document.getElementById('Try-again-box-red-text');
      const correctBoxRedtext = document.getElementById('correct-box-red-text');
      if (homeWiseathlete && correctBoxRed && tryAgainBoxRed && photoBoxRed)
      {  
        homeWiseathlete.addEventListener('mouseover', () => {
            homeWiseathlete.style.cursor = 'pointer';
        });
  
        homeWiseathlete.addEventListener('mouseout', () => {
            homeWiseathlete.style.cursor = 'default';
        });
  
        homeWiseathlete.addEventListener('click', () => {
          navigate('/');
        });

  
        correctBoxRed.addEventListener('mouseover', () => {
            correctBoxRed.style.cursor = 'pointer';
        });
  
        correctBoxRed.addEventListener('mouseout', () => {
            correctBoxRed.style.cursor = 'default';
        });
        correctBoxRed.addEventListener('click', onNext);
        
  
        tryAgainBoxRed.addEventListener('mouseover', () => {
            tryAgainBoxRed.style.cursor = 'pointer';
        });
  
        tryAgainBoxRed.addEventListener('mouseout', () => {
            tryAgainBoxRed.style.cursor = 'default';
        });
        tryAgainBoxRed.addEventListener('click',onNext);
        

        if(isTrue)
          {
            photoBoxRed.setAttribute('href',redImageMap[correctImage]);
          }
          else
          {
            photoBoxRed.setAttribute('href',redImageMap[wrongImage]);
          }


        if(isTrue) {
          tryAgainBoxRed.style.display = "none";
            correctBoxRedtext.textContent = "Next";
            
        }
        else {
          correctBoxRed.style.display = "none";
          tryAgainBoxRedtext.textContent = "Try Again";
        }
      }
     
    },[]);
  return (
    <div className="App-header-AfterRed">
      <RedPageAfterSVG/>
      <div className="question-discription-red-div">
          <p className="question-discription-red">{feedback}</p>
      </div>
    </div>
  );
}

export default RedPageAfter;